import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import {
  reactive,
  ref,
  computed,
  PropType,
} from 'vue';
import { required } from '@vuelidate/validators';
import { useI18n } from 'vue-i18n';

import { useForm } from '@/core/hooks/forms';
import { useFormErrorMessageHandler } from '@/utils/form';
import {
  useUpdateDeviceGroupMutation,
  useGetDeviceGroupQuery,
} from '@/entities/device-group/hooks';

import { DeviceGroup, UpdateDeviceGroupData } from '@/entities/device-group/types';

import {
  NkForm,
  NkFormItem,
  NkInputText,
  NkButton,
  NkGroup,
  NkTextArea,
} from '@/core/components';
import { ElAlert, ElNotification } from 'element-plus';
import { useFormUpdate } from '@/hooks/forms';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceGroupEdit',
  props: {
  deviceGroup: {
    type: Number as PropType<DeviceGroup['id']>,
    default: null,
  },
},
  emits: [],
  setup(__props, { emit }) {

const props = __props


const { onSubmitted } = useForm(emit);

const { t } = useI18n();



const queryData = computed(() => ({
  id: props.deviceGroup,
}));

const form = ref();
const fields = reactive({} as UpdateDeviceGroupData);
const rules = {
  name: { required },
  localization: { required },
};

const {
  mutation: {
    mutateAsync,
    isLoading,
    isError,
    error: updateDeviceGroupError,
  },
} = useFormUpdate({
  fields,
  queryData,
  mutationHook: useUpdateDeviceGroupMutation,
  queryHook: useGetDeviceGroupQuery,
});

const { error } = useFormErrorMessageHandler(updateDeviceGroupError);

const submit = () => {
  form.value.validator.$validate().then((valid: boolean) => {
    if (valid && !isLoading.value) {
      mutateAsync(
        fields,
        {
          onSuccess: () => ElNotification({
            title: t('device_group.notification.update.title'),
            message: t('device_group.notification.update.message'),
            type: 'success',
            position: 'bottom-right',
          }),
        },
      ).then((data) => {
        onSubmitted(data);
      });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkForm), {
    fields: fields,
    rules: rules,
    ref_key: "form",
    ref: form
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(NkGroup), { position: "right" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkButton), {
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('device_group.action.edit')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createBlock(_unref(ElAlert), {
            key: 0,
            type: "error",
            title: _unref(error)
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NkFormItem), {
        prop: "name",
        label: _ctx.$t('device_group.form.label.name')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkInputText), {
            modelValue: fields.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(NkFormItem), {
        prop: "localization",
        label: _ctx.$t('device_group.form.label.location')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkInputText), {
            modelValue: fields.localization,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fields.localization) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(NkFormItem), {
        label: _ctx.$t('device_group.form.label.comments')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkTextArea), {
            modelValue: fields.comment,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fields.comment) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }, 8, ["fields"])), [
    [_directive_loading, _unref(isLoading)]
  ])
}
}

})